
/* styles */
require("!!vue-style-loader!css-loader?{\"minimize\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index?{\"id\":\"data-v-52eac35c\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./about-company.vue")

var Component = require("!../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./about-company.vue"),
  /* template */
  require("!!../../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-52eac35c\"}!../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./about-company.vue"),
  /* scopeId */
  "data-v-52eac35c",
  /* cssModules */
  null
)
Component.options.__file = "D:\\a\\1\\s\\CutomerAppRazorPrerender\\scripts\\src\\pages\\about\\about-company.vue"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] about-company.vue: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (module.hot) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-52eac35c", Component.options)
  } else {
    hotAPI.reload("data-v-52eac35c", Component.options)
  }
})()}

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./scripts/src/pages/about/about-company.vue
// module id = 742
// module chunks = 0